import cn from "classnames";
import React from "react";

const SectionHeader = ({
	sectionTitle,
	sectionDescription,
	isLatestTrades = false,
}) => {
	return (
		<header className="border-b border-lightGrayBlue dark:border-darkSlateBlue px-6 md:px-8 pb-6">
			<h2
				className={cn(
					"text-black dark:text-white font-bold text-[20px] leading-[30px] md:text-2xl md:leading-9 mb-3",
					{
						"!text-2xl !leading-9": isLatestTrades,
					},
				)}
			>
				{sectionTitle}
			</h2>
			<p className="text-semiBlack dark:text-semiWhite text-xs leading-[14px] md:text-sm md:leading-4">
				{sectionDescription}
			</p>
		</header>
	);
};

export default SectionHeader;
